import BotTableRow from './bot-table-row';

export default BotTableRow;
